<template>
  <div>
    <b-row>
      <b-col cols="10">
        <b-form>
          <b-row>
            <b-col cols="2">
              <b-input-group-append v-b-tooltip.hover title="Порты могут быть созданы с аутентификацией и без для выполнения определённого анализа. Следующие инструменты принимают учётные данные для аутентифицированного анализа: Dirsearch, Gobuster, Nuclei, OWASP ZAP (все типы аутентификации), SMBMap (базовая аутентификация), JoomScan (cookie аутентификация) и Nikto (cookie и базовая аутентификация)">
                <b-button variant="outline">
                  <b-icon icon="info-circle-fill" variant="info"/>
                </b-button>
              </b-input-group-append>
            </b-col>
            <b-col cols="5">
              <b-form-input type="number" v-model="port" placeholder="Порт цели" :state="portState" autofocus/>
            </b-col>
            <b-col cols="5">
              <b-form-select v-model="type" :options="authenticationTypes">Тип аутентификации</b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="type !== 'None'" class="mt-3">
            <b-col>
              <b-form-group :invalid-feedback="invalidName">
                <b-form-input type="text" v-model="name" :placeholder="type === 'Basic' ? 'Имя пользователя' : type === 'Cookie' ? 'Имя cookie' : 'Имя учётных данных'" :state="nameState" autofocus/>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group :invalid-feedback="invalidCredential">
                <b-form-input type="password" v-model="credential" :placeholder="type === 'Basic' ? 'Пароль' : type === 'Cookie' ? 'Значение cookie' : 'Значение учётных данных'" :state="credentialState" autofocus/>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
      <b-col cols="2">
        <b-button variant="outline" @click="create" v-b-tooltip.hover title="Создать">
          <p class="h3"><b-icon variant="success" icon="plus-square-fill"/></p>
        </b-button>
      </b-col>
    </b-row>
    <b-table stripped head-variant="light" :fields="fields" :items="data" v-if="data.length > 0">
      <template #cell(authentication.type)="row">
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <b-form-select value="None" :options="authenticationTypes" @input="selectedItemToAddAuth = row.item" @change="selectTypeToAddAuth" v-if="!row.item.authentication"/>
        <p v-if="row.item.authentication">{{ row.item.authentication.type }}</p>
      </template>
      <template #cell(authentication.name)="row">
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <b-form-input type="text" v-model="nameToAddAuth" :placeholder="typeToAddAuth === 'Basic' ? 'Имя пользователя' : typeToAddAuth === 'Cookie' ? 'Имя cookie' : 'Имя учётных данных'" v-if="!row.item.authentication && selectedItemToAddAuth && selectedItemToAddAuth.id === row.item.id"/>
        <p v-if="!row.item.authentication && (!selectedItemToAddAuth || selectedItemToAddAuth.id !== row.item.id)"></p>
        <p v-if="row.item.authentication">{{ row.item.authentication.name }}</p>
      </template>
      <template #cell(authentication.credential)="row">
        <!-- eslint-disable-next-line vue/valid-v-slot -->
        <b-form-input type="password" v-model="credentialToAddAuth" :placeholder="typeToAddAuth === 'Basic' ? 'Пароль' : typeToAddAuth === 'Cookie' ? 'Значение cookie' : 'Значение учётных данных'" v-if="!row.item.authentication && selectedItemToAddAuth && selectedItemToAddAuth.id === row.item.id"/>
        <p v-if="!row.item.authentication && (!selectedItemToAddAuth || selectedItemToAddAuth.id !== row.item.id)"></p>
        <p v-if="row.item.authentication">{{ row.item.authentication.credential }}</p>
      </template>
      <template #cell(actions)="row">
        <b-button variant="outline" @click="createAuthentication" v-b-tooltip.hover title="Добавить аутентификацию" :disabled="!checkAuthentication(typeToAddAuth, nameToAddAuth, credentialToAddAuth, false)" v-if="selectedItemToAddAuth && selectedItemToAddAuth.id === row.item.id">
          <b-icon variant="success" icon="plus-square-fill"/>
        </b-button>
        <b-dropdown variant="outline" right v-b-tooltip.hover title="Удалить" v-if="row.item.authentication">
          <template #button-content>
            <b-icon variant="danger" icon="trash-fill"/>
          </template>
          <b-dropdown-item @click="selectedItem = row.item" v-b-modal.delete-port-modal>Удалить порт</b-dropdown-item>
          <b-dropdown-item @click="selectedItem = row.item.authentication" v-b-modal.delete-auth-modal>Удалить аутентификацию</b-dropdown-item>
        </b-dropdown>
        <b-button variant="outline" right v-b-tooltip.hover title="Удалить" @click="selectedItem = row.item" v-b-modal.delete-port-modal v-if="!row.item.authentication">
          <b-icon variant="danger" icon="trash-fill"/>
        </b-button>
      </template>
    </b-table>
    <deletion id="delete-port-modal" title="Удалить порт" @deletion="deletePort" @clean="selectedItem = null" v-if="selectedItem !== null">
      <span>порт <strong>{{ selectedItem['port'] }}</strong></span>
    </deletion>
    <deletion id="delete-auth-modal" title="Удалить аутентификацию" @deletion="deleteAuthentication" @clean="selectedItem = null" v-if="selectedItem !== null">
      <span>аутентификацию <strong>{{ selectedItem['name'] }}</strong></span>
    </deletion>
    <pagination :page="page" :limit="limit" :limits="limits" :total="total" name="ports" @pagination="pagination"/>
  </div>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi';
import Deletion from '@/common/Deletion';
import Pagination from '@/common/Pagination';
export default {
  name: 'targetPortModal',
  mixins: [RekonoApi],
  props: {
    targetId: Number,
  },
  computed: {
    fields () {
      let fields = [
        { key: 'port', label: 'Порт', sortable: true },
        { key: 'authentication.type', label: 'Тип аутентификации', sortable: true },
        { key: 'authentication.name', label: 'Имя', sortable: true },
        { key: 'authentication.credential', label: 'Учётные данные', sortable: true }
      ]
      if (this.auditor.includes(this.$store.state.role)) {
        fields.push({ key: 'actions', label: 'Действия', sortable: false })
      }
      return fields
    }
  },
  data () {
    this.fetchData()
    return {
      limit: 10,
      limits: [10, 25, 50, 100],
      data: [],
      selectedItem: null,
      port: null,
      type: 'None',
      name: null,
      credential: null,
      selectedItemToAddAuth: null,
      typeToAddAuth: 'None',
      nameToAddAuth: null,
      credentialToAddAuth: null,      
      invalidPort: 'Порт цели обязателен',
      invalidName: 'Имя учётных данных обязательно',
      invalidCredential: 'Значение учётных данных обязательно',
      portState: null,
      nameState: null,
      credentialState: null
    }
  },
  components: {
    Deletion,
    Pagination
  },
  methods: {
    fetchData () {
      return this.getOnePage('/api/target-ports/', { o: 'port', target: this.targetId })
        .then(response => {
          this.data = response.data.results
          this.total = response.data.count
        })
    },
    checkPort () {
      this.portState = null
      if (!this.port || this.port < 0 || this.port > 999999) {
        this.portState = false
        this.invalidPort = this.port ? 'Неверное значение порта' : 'Порт цели обязателен'
      }
      return this.portState !== false
    },
    checkAuthentication (type = this.type, name = this.name, credential = this.credential, changeState = true) {
      if (changeState) {
        this.nameState = null
        this.credentialState = null
      }
      if (type !== 'None') {
        if (!this.validateName(name)) {
          if (changeState) {
            this.techState = false
            this.invalidName = name && name.length > 0 ? 'Неверное имя учётных данных' : 'Имя учётных данных обязательно'
          } else {
            return false
          }
        }
        if (!this.validateCredential(credential)) {
          if (changeState) {
            this.credentialState = false
            this.invalidCredential = credential && credential.length > 0 ? 'Неверное значение учётных данных' : 'Значение учётных данных обязательно'
          } else {
            return false
          }
        }
      }
      return changeState ? this.nameState !== false && this.credentialState !== false : true
    },
    create () {
      if (this.checkPort() && this.checkAuthentication()) {
        this.post('/api/target-ports/', { target: this.targetId, port: this.port }, this.port, 'Новый порт цели создан успешно')
          .then(data => {
            if (this.type !== 'None') {
              this.post(
                '/api/authentications/',
                { target_port: data.id, name: this.name, credential: this.credential, type: this.type},
                this.name, 'Новая аутентификация создана успешно'
              )
                .then(() => this.fetchData())
                .catch(() => this.fetchData())
            } else {
              this.fetchData()
            }
            this.clean()
          })
        .catch(() => this.clean())
      }
      else {
        this.clean()
      }
    },
    createAuthentication () {
      if (this.selectedItemToAddAuth && this.checkAuthentication(this.typeToAddAuth, this.nameToAddAuth, this.credentialToAddAuth, false)) {
        this.post(
          '/api/authentications/',
          { target_port: this.selectedItemToAddAuth.id, name: this.nameToAddAuth, credential: this.credentialToAddAuth, type: this.typeToAddAuth},
          this.nameToAddAuth, 'Новая аутентификация создана успешно'
        )
          .then(() => this.fetchData())
        this.selectedItemToAddAuth = null
        this.typeToAddAuth = null
        this.nameToAddAuth = null
        this.credentialToAddAuth = null
      }
    },
    deletePort () {
      this.delete(`/api/target-ports/${this.selectedItem.id}/`, this.selectedItem.port, 'Порт удалён успешно').then(() => this.fetchData())
    },
    deleteAuthentication () {
      this.delete(`/api/authentications/${this.selectedItem.id}/`, this.selectedItem.name, 'Аутентификация удалена успешно').then(() => this.fetchData())
    },
    selectTypeToAddAuth (type) {
      if (type === 'None') {
        this.selectedItemToAddAuth = null
      } else {
        this.typeToAddAuth = type
      }
    },
    clean () {
      this.selectedItem = null
      this.port = null
      this.type = 'None'
      this.name = null
      this.credential = null
      this.selectedItemToAddAuth = null
      this.typeToAddAuth = null
      this.nameToAddAuth = null
      this.credentialToAddAuth = null
      this.portState = null
      this.nameState = null
      this.credentialState = null
    }
  }
}
</script>
